import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const ADMIN_LIST_KEY = "adminList";
const SIGNUP_LIST_OPTION = "signupListOption"

const signupsKeys = createKeys(featureKeys.SIGNUPS_KEY, {
  // possibly don't need the signupID and it may be the same for everyone in the same network. Maybe it should just be networkID
  adminList: ({ signupID } = {}) => [
    ADMIN_LIST_KEY,
    signupID
  ],
  signupListOption: ({ signupID } = {}) => [
    SIGNUP_LIST_OPTION,
    signupID,
  ]
});

export default signupsKeys;